export default {
  PUBLIC: "公眾帳戶",
  SCHOOL_BASED_TEACHER: "校本教師帳戶",
  INDIVIDUAL_TEACHER: "個人教師帳戶",
  STUDENT: "學生帳戶",
  SCHOOL_ADMINISTRATOR: "學校管理員帳戶",
  SCHOOL: "學校職員帳戶",
  CORPORATE_ADMINISTRATOR: "企業管理員帳戶",
  OTHER: "其他",
  STUDENT_MEMBER:"學生會員",
  FULL_MEMBER:"會員",
  SCHOOL_PURCHASER:"學校採購員帳戶",
};
